class AuthHelper {
  isAuthenticated = () => !!window.localStorage.accessToken
}

export default new AuthHelper();
